// extracted by mini-css-extract-plugin
export default {"headerArrows":"iRZii5DR","arrow":"qlMXpOdV","_inactive":"ss7fGEXc"};